<template>
  <div class="salesmanPage">
    <headerNotice routerName="业务员列表"></headerNotice>
    <!-- 搜索条 -->
    <div class="searchBox">
      <el-form :inline="true" :model="salesmanSearchForm" class="demo-form-inline searchForm">
        <el-form-item label="姓名">
          <el-input v-model="salesmanSearchForm.realName" clearable placeholder="请输入姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="所属仓库仓库"> 
          <el-select v-model="salesmanSearchForm.HouseId" placeholder="请选择所属仓库">
            <el-option label="请选择所属仓库" :value="0"></el-option>
            <el-option
              v-for="item in houseList"
              :key="item.houseID"
              :label="item.houseName"
              :value="item.houseID"
            ></el-option>
          </el-select>
      </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="salesmanSearchForm.userName" clearable placeholder="请输入登录账号">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </el-form-item>
        <el-button type="primary" slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        <el-form-item label="账号状态">
          <el-select
            v-model="salesmanSearchForm.status"
            clearable
            placeholder="请选择账号状态"
            @change="onChange"
          >
            <el-option label="已启用" value="1"></el-option>
            <el-option label="未启用" value="0"></el-option>
          </el-select>
        </el-form-item>
        
        <div class="btnGroup">
          <el-button type="primary" icon="el-icon-plus" @click="onAddSalesman">新增</el-button>
        </div>
      </el-form>
    </div>
    <!-- 搜索结果列表 -->
    <div class="searchList">
      <div class="searchListContent">
        <el-table
          ref="searchListTable"
          :data="salesmanTableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          v-loading="loading"
        >
          <el-table-column align="center" type="index" label="序号" width="55"></el-table-column>
          <el-table-column align="center" prop="realName" label="姓名" width="180"></el-table-column>
          <el-table-column align="center" prop="userName" label="登录账号" width="220"></el-table-column>
		  <el-table-column align="center" prop="salesmanCode" label="业务员编号" width="220"></el-table-column>
         <el-table-column align="center" prop="houseName" label="所属仓库" width="220"></el-table-column>
          <el-table-column align="center" prop="balance" label="预存款余额">
            <template slot-scope="scope">
              <span
                class="detialSpan"
                @click="onBalanceDetial(scope.row,scope.$index)"
              >{{scope.row.balance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="phone" label="手机" width="180"></el-table-column>
          <el-table-column align="center" prop="integral" label="积分">
            <template slot-scope="scope">
              <span
                class="detialSpan"
                @click="onIntegralDetial(scope.row,scope.$index)"
              >{{scope.row.integral}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="启用状态" width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.status ==0">未启用</span>
              <span v-if="scope.row.status ==1">启用</span>
            </template>
          </el-table-column>
     
          <el-table-column align="center" fixed="right" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onSalesmanDetail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="onEditSalesman(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="onBalanceIntegral(scope.row)">调整余额/积分</el-button>
              <!-- 上级要求删除功能暂时隐藏 -->
              <!-- <el-button type="text" size="small" @click='delSalesman(scope.row.userId)'>删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--搜索列表分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <!-- 查看业务员信息弹框 -->
    <el-dialog
      title="业务员信息"
      :visible.sync="salesmanDetailVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="addSalesmanContent" v-loading="loading">
        <div class="editTitle">
          <h2>基本信息</h2>
        </div>
        <el-form
          :inline="false"
          ref="addSalesmanForm"
          :model="addSalesmanForm"
          label-width="120px"
          class="addSalesmanForm"
        >
          <div class="formLeft">
            <el-form-item label="业务员姓名">
              <el-input v-model="addSalesmanForm.realName" clearable :readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="addSalesmanForm.phone" clearable :readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="Email">
              <el-input v-model="addSalesmanForm.eMail" clearable :readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="微信">
              <el-input v-model="addSalesmanForm.weiXin" clearable :readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="QQ">
              <el-input v-model="addSalesmanForm.qq" clearable :readonly="readonly"></el-input>
            </el-form-item>
			<el-form-item label="业务员编号">
			  <el-input v-model="addSalesmanForm.salesmanCode" clearable :readonly="readonly"></el-input>
			</el-form-item>
             <el-col :span="10">
                    <el-form-item label="所属仓库" prop="houseID">
                    <el-select v-model="addSalesmanForm.houseID" value-key="houseID" prop="houseID"  class="house" placeholder="请选择所属仓库">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option
                        v-for="item in houseList"
                        :key="item.houseID"
                        :label="item.houseName"
                        :value="item"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                </el-col>
          </div>
          <div class="formRight">
            <img :src="baseUrl+addSalesmanForm.headImgUrl" alt />
          </div>
        </el-form>
        <div class="editTitle">
          <h2>业务员账户</h2>
        </div>
        <el-form
          :inline="false"
          ref="addSalesmanForm"
          :model="addSalesmanForm"
          label-width="120px"
          class="addSalesmanForm"
        >
          <div class="formLeft">
            <el-form-item label="账号">
              <el-input v-model="addSalesmanForm.userName" clearable :readonly="readonly"></el-input>
            </el-form-item>
            <!-- 暂时不显示 -->
            <!-- <el-form-item label="密码">
                            <el-input
                                v-model="addSalesmanForm.password"
                                clearable
                                :readonly="readonly"
                            ></el-input>
            </el-form-item>-->
            <el-form-item label="账号状态">
              <el-radio-group v-model="addSalesmanForm.status" disabled>
                <el-radio :label="1">开通</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="salesmanDetailVisible = false">关闭</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 调整积分/余额弹框 -->
    <el-dialog
      title="调整余额/积分"
      :visible.sync="changeBalanceIntegralFormVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="changeBalanceIntegralForm"
        label-width="100px"
        class="changeBalanceIntegralForm"
      >
        <el-form-item label="调整余额">
          <el-radio
            v-model="balanceIntegralRadio.balance"
            label="1"
            @change="balanceIntegralChange"
          >增加</el-radio>
          <el-input
            v-model="changeBalanceIntegralForm.addBalanceNum"
            autocomplete="off"
            placeholder="请输入大于0的正整数"
            :disabled="balanceIntegralDisabled1"
          >
            <span slot="append">元</span>
          </el-input>
          <el-radio
            v-model="balanceIntegralRadio.balance"
            label="2"
            @change="balanceIntegralChange"
          >减少</el-radio>
          <el-input
            v-model="changeBalanceIntegralForm.reduceBalanceNum"
            autocomplete="off"
            placeholder="请输入大于0的正整数"
            :disabled="balanceIntegralDisabled2"
          >
            <span slot="append">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="调整积分">
          <el-radio
            v-model="balanceIntegralRadio.integral"
            @change="balanceIntegralChange"
            label="1"
          >增加</el-radio>
          <el-input
            v-model="changeBalanceIntegralForm.addIntegralNum"
            autocomplete="off"
            placeholder="请输入大于0的正整数"
            :disabled="balanceIntegralDisabled3"
          >
            <span slot="append">分</span>
          </el-input>
          <el-radio
            v-model="balanceIntegralRadio.integral"
            @change="balanceIntegralChange"
            label="2"
          >减少</el-radio>
          <el-input
            v-model="changeBalanceIntegralForm.reduceIntegralNum "
            autocomplete="off"
            placeholder="请输入大于0的正整数"
            :disabled="balanceIntegralDisabled4"
          >
            <span slot="append">分</span>
          </el-input>
        </el-form-item>
        <el-form-item label="获取验证码">
          <el-input value="13539326768" placeholder="请输入手机号" disabled="disabled">
            <el-button @click="getCode" slot="append">{{codeText}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model.trim="changeBalanceIntegralForm.code" style="width: 335px;"></el-input>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input type="textarea" v-model="changeBalanceIntegralForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetChangeBalanceIntegralForm">取 消</el-button>
        <el-button type="primary" @click="sendBalanceIntegral">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      baseUrl: this.$store.state.ossUrl,
      userId: "",
      salesmanSearchForm: {
        //搜索表单
        userName: "",
        status: "",
        SkipCount: 0
      },
      salesmanTableData: [], //表单数据
      salesmanDetailVisible: false, //业务员详情弹窗
      changeBlanceIntegralFormVisible: false, //调整积分余额弹窗
      changeBlanceIntegralForm: {
        balance: "",
        integral: "",
        remark: ""
      },
      readonly: true,
      addSalesmanForm: {
        // salesmanName: '测试',
        // contactTel: '1231231123',
        // salesmanMail: '123@123.com',
        // salesmanQQ: '23345546456',
        // salesmanWeixin: '1231231123',
        // headImgUrl: require('./../../assets/imgs/touxiang.png'),
        // accountNum: '1231231123',
        // contactTel: '1231231123',
        // enableState: '1'
      },
       houseList: [],//所属仓库
      changeBalanceIntegralFormVisible: false, //更改余额积分表单弹窗
      changeBalanceIntegralForm: {
        //更改余额积分表单
        addBalanceNum: "",
        reduceBalanceNum: "",
        addIntegralNum: "",
        reduceIntegralNum: "",
        remark: "",
        phone: "",
        code: ""
      },
      balanceIntegralRadio: {
        //修改余额积分单选按钮控制
        balance: "1",
        integral: "1"
      },
      balanceIntegralDisabled1: false, //修改余额积分输入控制
      balanceIntegralDisabled2: true,
      balanceIntegralDisabled3: false,
      balanceIntegralDisabled4: true,
      CustomerSalesmanSelection: [],
      codeText: "获取验证码",
      remainSecond: 0,
      codeTimer: null
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount
    });
    this.getSelectData();
  },
  methods: {
       //获取下拉数据
        getSelectData() {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Warehouse/GetAllWareHouse",
                success(res) {
                    self.houseList = res;
                },
                fail(res) {
                }
            })
        },
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
        params: params,
        success(res) {
          self.salesmanTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
    // 获取验证码
    getCode() {
      let self = this;
      // if(self.changeBalanceIntegralForm.phone.length != 11) {
      //     self.$message.error('请输入正确的手机号')
      //     return
      // }
      if (self.remainSecond > 1) {
        return;
      }
      self.remainSecond = 61;
      clearInterval(timer);
      let timer = setInterval(() => {
        if (self.remainSecond > 1) {
          self.remainSecond -= 1;
          self.codeText = `重新获取(${self.remainSecond}s)`;
        } else {
          clearInterval(timer);
          self.codeText = "重新获取";
        }
      }, 1000);
       var money=0;
	  if(self.balanceIntegralRadio.balance=="1")
	  {
		  money=self.changeBalanceIntegralForm.addBalanceNum;
	  }else{
		  money=self.changeBalanceIntegralForm.reduceBalanceNum;
	  }
      self.codeTimer = timer;
      $http.POST({
        url: this.$store.state.apiUrl + "/api/services/app/SmsCode/SendSmsByName",
        data: {
          customerName:self.customerName,
          money: money,
          phone: 13539326768
           //phone: 13725240926, // 测试
        },
        success(res) {
          self.$message.success("发送成功");
          // self.loading = false;
        },
        fail(res) {
          // console.log(res);
          // self.loading = false;
        }
      });
    },
    //搜索
    onSearch(params) {
      let self = this;
      let form = this.salesmanSearchForm;
      //关闭弹窗
      this.dialogSearchForm2Visible = false;
      form.SkipCount = 0;
      this.getDatas(form);
      this.currentPage = 1;
    },
    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      this.getDatas(params);
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.salesmanSearchForm;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    },
    handleSelectionChange(val) {
      this.CustomerSalesmanSelection = val;
      console.log(this.CustomerSalesmanSelection);
    },
    onChange() {
      console.log("onChange");
    },
    // 删除
    delSalesman(id) {
      let self = this;
      this.$confirm("此操作将永久删除该业务员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.loading = true;
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminSalesman/Delete",
            params: { userId: id },
            success(res) {
              self.$message.success(res.data);
              self.onSearch();
              self.loading = false;
            },
            fail(res) {
              console.log(res);
              self.loading = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //跳转增加业务员
    onAddSalesman() {
      this.$router.push({
        path: "/addSalesman"
      });
    },
    //跳转修改业务员
    onEditSalesman(row) {
      this.$router.push({
        path: "/editSalesman",
        query: {
          userId: row.userId
        }
      });
    },
    //打开查看详情弹窗
    onSalesmanDetail(row) {
      let self = this;
      this.salesmanDetailVisible = true;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetInfo",
        params: { userId: row.userId },
        success(res) {
          console.log(res);
          self.addSalesmanForm = res;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
    //打开调整积分/余额弹框
    onBalanceIntegral(row) {
      this.userId = row.userId;
      this.changeBalanceIntegralFormVisible = true;
    },
    //提交调整积分/余额
    sendBalanceIntegral() {
      let self = this;
      if (self.changeBalanceIntegralForm.code.length == 0) {
        self.$message.error("请输入验证码");
      }
      let addBalanceNum = parseInt(
        this.changeBalanceIntegralForm.addBalanceNum
      );
      let reduceBalanceNum = parseInt(
        this.changeBalanceIntegralForm.reduceBalanceNum
      );
      let addIntegralNum = parseInt(
        this.changeBalanceIntegralForm.addIntegralNum
      );
      let reduceIntegralNum = parseInt(
        this.changeBalanceIntegralForm.reduceIntegralNum
      );
      let remark = this.changeBalanceIntegralForm.remark;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminUser/ModifyBalanceOrIntegral",
        data: {
          addBalanceNum: addBalanceNum,
          reduceBalanceNum: reduceBalanceNum,
          addIntegralNum: addIntegralNum,
          reduceIntegralNum: reduceIntegralNum,
          remark: remark,
          userId: self.userId,
          // phone: self.changeBalanceIntegralForm.phone,
          phone: 13539326768,
          // phone: 15602212902, // 测试
          code: self.changeBalanceIntegralForm.code
        },
        success(res) {
          console.log(res);
          self.$message({
            message: res.data,
            type: "success"
          });
          self.resetChangeBalanceIntegralForm();
          self.onSearch();
        },
        fail(res) {
          console.log(res);
        }
      });
    },
    //重置调整积分/余额
    resetChangeBalanceIntegralForm() {
      this.changeBalanceIntegralForm.addBalanceNum = "";
      this.changeBalanceIntegralForm.reduceBalanceNum = "";
      this.changeBalanceIntegralForm.addIntegralNum = "";
      this.changeBalanceIntegralForm.reduceIntegralNum = "";
      this.changeBalanceIntegralForm.remark = "";
      this.changeBalanceIntegralFormVisible = false;
      this.balanceIntegralRadio.balance = "1";
      this.balanceIntegralRadio.integral = "1";
      this.balanceIntegralDisabled1 = false;
      this.balanceIntegralDisabled2 = true;
      this.balanceIntegralDisabled3 = false;
      this.balanceIntegralDisabled4 = true;
      this.changeBalanceIntegralForm.phone = "";
      this.changeBalanceIntegralForm.code = "";
      clearInterval(this.codeTimer);
      this.remainSecond = 0;
      this.codeText = "获取验证码";
    },
    //调整积分/余额判断input启用
    balanceIntegralChange() {
      if (this.balanceIntegralRadio.balance == 1) {
        this.balanceIntegralDisabled1 = false;
        this.balanceIntegralDisabled2 = true;
      } else {
        this.balanceIntegralDisabled1 = true;
        this.balanceIntegralDisabled2 = false;
      }
      if (this.balanceIntegralRadio.integral == 1) {
        this.balanceIntegralDisabled3 = false;
        this.balanceIntegralDisabled4 = true;
      } else {
        this.balanceIntegralDisabled3 = true;
        this.balanceIntegralDisabled4 = false;
      }
    },
    //跳转余额明细
    onBalanceDetial(row, index) {
      console.log(row);
      sessionStorage.setItem("moneyDetialForm", JSON.stringify(row));
      this.$router.push({
        path: "/moneyDetial",
        query: {
          goodsId: "balance",
          userId: row.userId
        }
      });
    },
    //跳转积分明细
    onIntegralDetial(row) {
      console.log(row);
      sessionStorage.setItem("moneyDetialForm", JSON.stringify(row));
      this.$router.push({
        path: "/moneyDetial",
        query: {
          goodsId: "integral",
          userId: row.userId
        }
      });
    }
  }
};
</script>


<style lang='scss' scoped>
.salesmanPage {
  //搜索框
  .searchBox {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchForm {
      padding-left: 20px;
      align-items: center;
      min-height: 106px;
      display: flex;
      .el-form-item {
        margin-bottom: 0;
      }
      .btnGroup {
        width: 50%;
        text-align: right;
      }
      .el-button--primary {
        margin-right: 20px
      }
    }
  }
  //搜索列表
  .searchList {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchListHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding-left: 20px;
      background: #efefef;
      border-bottom: 1px solid #c5c5c5;

      .searchListCtl {
        button,
        .el-select {
          width: 130px;
          margin-left: 10px;
        }
      }
    }
    .searchListContent {
      .detialSpan {
        color: #ff9400;
        cursor: pointer;
      }
    }
  }
  //查看
  .addSalesmanContent {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    display: flex;
    flex-direction: column;
    align-items: center;
    .editTitle {
      height: 40px;
      line-height: 40px;
      align-self: normal;
      margin-bottom: 10px;
      padding-left: 20px;
      border-bottom: 1px solid #c5c5c5;
    }
    .addSalesmanForm {
      display: flex;
      .formLeft {
        margin-right: 20px;
      }
      .formRight {
        margin-left: 20px;
        img {
          width: 220px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.changeBalanceIntegralForm {
  .el-input-group {
    width: 80%;
  }
  .el-radio {
    margin-right: 20px;
  }
  .el-textarea {
    width: 96.5%;
  }
}
.house{
    width:200px;
}
</style>

